import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AccessCardsBatchListComponent from './AccessCardsBatchListComponent';

import { confirmDeleteAccessCard, getAccessCardsList } from './actions';

const LIST_KEY = 'accessCardsBatch';

const AccessCardsBatchListContainer = (props) => {
  const { onGetAccessCardsList, listParams } = props;
  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetAccessCardsList(queryParams);
  };
  return <AccessCardsBatchListComponent {...props} onExport={onExport} />;
};

AccessCardsBatchListContainer.propTypes = {
  onGetAccessCardsList: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => {
  const {
    accessCards: { batch: items = {} },
  } = state;
  return {
    items,
    listKey: LIST_KEY,
    listParams: get(state, `lists.${LIST_KEY}`, {}),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {},
  getItems: (queryParams) => getAccessCardsList(dispatch, queryParams, true),
  onRemove: (id, queryParams) =>
    confirmDeleteAccessCard(dispatch, id, queryParams, true),
  onGetAccessCardsList: (queryParams) =>
    getAccessCardsList(dispatch, queryParams, true, true),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccessCardsBatchListContainer);
